import axios from "axios";

export const getAxiosError = (error: unknown, fallback = "Something went wrong"): string => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.error || error.response?.data?.message || fallback;
  }

  return fallback;
};
